export const getSportsnewBackUrl = () => process.env.REACT_APP_BACK_URL;
